export default class DateSelector {
    constructor(root) {
        this.root = root;
        this.sheet = root.sheet;
        this.config = root.config;

        this.$date_selector_header = $('<div class="f-calendar__date-selector--header"> </div>');
        this.$date_selector_trigger = $('<div class="f-calendar__date-selector--trigger"> </div>');
        this.$date_selector_current_date = $('<div class="f-calendar__date-selector--current-date"></div>');
        this.$date_selector_arrows = $('<div class="f-calendar__date-selector--arrows"> </div>');
        this.$date_selector_arrow_down = $(`
            <div class="f-calendar__date-selector--arrow-down">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5 4L9 0L10 1L5 6L0 1L1 0L5 4Z" fill="#222D39"/>
                </svg>
            </div>
        `);
        this.$date_selector_arrow_up = $(`
            <div class="f-calendar__date-selector--arrow-up" style="display: none">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5 4L9 8L10 7L5 2L0 7L1 8L5 4Z" fill="#222D39"/>
                </svg>
            </div>
        `);
        this.$date_selector_close_btn = $(`
            <div class="f-calendar__date-selector--close-btn">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 5L11 0L12 1L7 6L12 11L11 12L6 7L1 12L0 11L5 6L0 1L1 0L6 5Z" fill="currentColor"/>
                </svg>
            </div>
        `);

        this.$date_selector = $('<div class="f-calendar__date-selector"></div>');
        this.$date_selector_container = $('<div class="f-calendar__date-selector--container"></div>');
        this.$date_selector_year_list = $('<div class="f-calendar__date-selector--year-list f-calendar_scrollable"></div>');
        this.$date_selector_month_list = $('<div class="f-calendar__date-selector--month-list"></div>');

        this.observerInited = null;
        this.buildedSelector = false;
        this.observed = [];

        this.showed = false;

        this.viewedDate = {
            month: 0,
            year: 0
        };

        this.selectedStage = {
            month: false,
            year: false
        };
    }

    buildHeader() {
        this.$date_selector_trigger.append(this.$date_selector_current_date);
        this.$date_selector_arrows.append(this.$date_selector_arrow_down);
        this.$date_selector_arrows.append(this.$date_selector_arrow_up);
        this.$date_selector_trigger.append(this.$date_selector_arrows);

        this.$date_selector_header.append(this.$date_selector_trigger);
        this.$date_selector_header.append(this.$date_selector_close_btn);

        return this.$date_selector_header;
    }

    buildSelector() {
        if (this.buildedSelector) {
            return this.$date_selector;
        }

        this.$date_selector_container.append(this.$date_selector_month_list);
        this.$date_selector_container.append(this.$date_selector_year_list);
        this.$date_selector.append(this.$date_selector_container);

        const config = this.config.get();

        config.locale.month.forEach((month, index) => {
            const $date_selector_month_item = $(`<div class="f-calendar__date-selector--month-item">${ month }</div>`);
            $date_selector_month_item.attr('month', index);

            this.$date_selector_month_list.append($date_selector_month_item);
        });

        const upperYear = config.upperLimit.year;
        const lowerYear = config.lowerLimit.year;

        let i = upperYear;
        /* eslint no-loops/no-loops: 0 */
        while (i >= lowerYear) {
            const $date_selector_year_item = $(`<div class="f-calendar__date-selector--year-item">${ i }</div>`);
            $date_selector_year_item.attr('year', i);

            this.$date_selector_year_list.append($date_selector_year_item);
            i -= 1;
        }

        // this.$date_selector.hide();

        this.buildedSelector = true;

        return this.$date_selector;
    }

    showSelector() {
        this.showed = true;

        this.$date_selector_arrow_down.hide();
        this.$date_selector_arrow_up.fadeIn();

        this.$date_selector.addClass('f-calendar__date-selector_opened');


        this.selectedStage = {
            month: false,
            year: false
        };
    }

    hideSelector() {
        this.showed = false;

        this.$date_selector_arrow_up.hide();
        this.$date_selector_arrow_down.fadeIn();

        this.$date_selector.removeClass('f-calendar__date-selector_opened');

        // setTimeout(() => {
        //     this.$date_selector.hide();
        // }, 500);
    }

    initObserver() {
        if (this.observerInited) {
            return false;
        }

        this.observerInited = true;

        let lastMonth;

        this.sheet.$sheet.off('scroll.dateSelector');
        this.sheet.$sheet.on('scroll.dateSelector', $.throttle((e) => {
            const fix = 25;
            const scrollTop = e.currentTarget.scrollTop;

            let month = null;

            // Перебираем все наблюдаемые года
            this.observed.some((item) => {
                const year = item.el;
                const months = item.months;

                const yearTop = year.offsetTop;
                const yearBottom = yearTop + year.offsetHeight;

                // Год на экране, ищем подходящий месяц
                if ((yearTop - fix) <= scrollTop && yearBottom >= scrollTop) {
                    return months.some((el) => {
                        const monthTop = el.offsetTop - fix;

                        // Месяц ниже скрола, значит пора остановиться
                        if (scrollTop <= (yearTop + monthTop)) {
                            return true;
                        }

                        month = el;
                    });
                }
            });

            // Обновляем шапку
            if (month && lastMonth !== month) {
                lastMonth = month;
                const viewedDate = {
                    month: Number(month.getAttribute('month')),
                    year: Number(month.getAttribute('year'))
                };

                this.setHeader(viewedDate);
                this.viewedDate = viewedDate; // Пишем в состояние отображаемую дату
            }
        }, 50));
    }

    observeYear(el) {
        const $year = $(el);
        const year = el.getAttribute('year');

        const months = $year.find('.f-calendar__sheet--month').map((_i, el) => el).toArray();

        this.observed.push({
            el,
            year,
            months
        });

        this.observed = this.observed.sort((a, b) => a.year - b.year);
    }

    unobserveYear(el) {
        const year = el.getAttribute('year');

        const index = this.observed.findIndex(item => item.year === year);

        if (index >= 0) {
            this.observed.splice(index, 1);
        }
    }

    scrollYearListToActive() {
        // Находим элемент с искомым месяцем и скроллим
        const $year = this.$date_selector_year_list.find(`[year=${ this.viewedDate.year }]`);

        if (!$year.length) {
            console.warn('scrollToYear() - Year not found');
            return;
        }

        // Обнуляем скролл
        this.$date_selector_year_list.scrollTop(0);

        // Измеряем куда будем скроллить
        const scrollTo = $year[0].offsetTop;

        // Скроллим до выбранного месяца
        this.$date_selector_year_list.scrollTop(scrollTo - 100);
    }

    setHeader({ month, year }) {
        const { locale } = this.config.get();

        if (typeof +month === 'number') {
            this.viewedDate.month = +month;
        }

        if (typeof +year === 'number') {
            this.viewedDate.year = +year;
        }

        const headerStr = `${ locale.month[month] }, ${ year }`;

        this.$date_selector_current_date.html(headerStr);
    }

    highligthItems(payload) {
        if (!this.showed) {
            return;
        }

        if (!payload) {
            payload = this.viewedDate;
        }

        this._highligthActive(payload);
        this._highligthDisabled(payload);
    }

    _highligthActive({ month, year }) {
        this.$date_selector_month_list
            .find('.f-calendar__date-selector--month-item')
            .removeClass('f-calendar__date-selector--month-item_active');

        this.$date_selector_year_list
            .find('.f-calendar__date-selector--year-item')
            .removeClass('f-calendar__date-selector--year-item_active');

        this.$date_selector_month_list
            .find(`.f-calendar__date-selector--month-item[month=${ month }]`)
            .addClass('f-calendar__date-selector--month-item_active');

        this.$date_selector_year_list
            .find(`.f-calendar__date-selector--year-item[year=${ year }]`)
            .addClass('f-calendar__date-selector--year-item_active');
    }

    _highligthDisabled({ year }) {
        const { upperLimit, lowerLimit } = this.config.get();

        this._clearDisabledMonth();

        if (lowerLimit.year === year) {
            let i = 0;
            while (i < lowerLimit.month) {
                const $month_item = this.$date_selector_month_list.find(`[month=${ i }]`);
                $month_item.addClass('f-calendar__date-selector--month-item_disabled');

                i += 1;
            }
        }

        if (upperLimit.year === year) {
            let i = upperLimit.month;
            while (i <= 11) {
                i += 1;

                const $month_item = this.$date_selector_month_list.find(`[month=${ i }]`);
                $month_item.addClass('f-calendar__date-selector--month-item_disabled');
            }
        }
    }

    _clearDisabledMonth() {
        const $months = this.$date_selector_month_list.find('.f-calendar__date-selector--month-item');

        $months.removeClass('f-calendar__date-selector--month-item_disabled');
    }

    setAndCheckSelectedStage(direction) {
        if (direction === 'month') {
            this.selectedStage.month = true;
        }
        else if (direction === 'year') {
            this.selectedStage.year = true;
        }

        return this.selectedStage.month && this.selectedStage.year;
    }
}
